import React, { useState } from 'react'
import { Drawer, IconButton, makeStyles, Typography, Box, Divider, Button } from '@material-ui/core'
import CloseIcon from '@material-ui/icons/Close'
import HelpOutlineIcon from '@material-ui/icons/HelpOutline'
import { useLocation, useNavigate } from 'react-router-dom'
import { useRecoilValue } from 'recoil'
import { userInfoState } from '../../recoil/atoms'
import { helpFor, ROLE_LABEL, activeRoleOf } from '../../assets/helpContent'

const useStyles = makeStyles(() => ({
  paper: { width: 360, maxWidth: '92vw', background: '#fbfcff' },
  header: {
    background: 'linear-gradient(135deg, #1a237e 0%, #4b3fa7 100%)',
    color: '#fff',
    padding: '14px 16px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  role: {
    fontSize: 10.5,
    fontWeight: 700,
    background: 'rgba(255,255,255,.18)',
    borderRadius: 999,
    padding: '2px 10px',
  },
  section: { background: '#f4f6fb', border: '1px solid #e3e6f2', borderRadius: 12, padding: 12, marginTop: 10 },
  tip: {
    background: '#fff8e1',
    border: '1px dashed #f9a825',
    borderRadius: 10,
    padding: '8px 10px',
    marginTop: 8,
    fontSize: 12,
    color: '#7a5c00',
  },
}))

/** کشوی راهنمای همان صفحه — آیکن «؟» در نوار بالا، هماهنگ با نقشِ واردشده */
const HelpDrawer = () => {
  const classes = useStyles()
  const [open, setOpen] = useState(false)
  const location = useLocation()
  const navigate = useNavigate()
  const userInfo = useRecoilValue(userInfoState)
  const role = activeRoleOf(userInfo)

  const baseRoute = ('/' + location.pathname.replace(/^\/+/, '')).split('?')[0]
  const content = helpFor(baseRoute, role)

  return (
    <>
      <IconButton color="inherit" onClick={() => setOpen(true)} title="راهنمای همین صفحه"
        style={{ marginRight: 4 }}>
        <HelpOutlineIcon />
      </IconButton>

      <Drawer anchor="right" open={open} onClose={() => setOpen(false)}
        classes={{ paper: classes.paper }}>
        <Box className={classes.header}>
          <Box>
            <Typography style={{ fontWeight: 800, fontSize: 15 }}>
              ❓ راهنما {content ? '— ' + content.title : ''}
            </Typography>
            <Typography className={classes.role} style={{ marginTop: 4, display: 'inline-block' }}>
              نقش: {ROLE_LABEL[role] || role || '—'}
            </Typography>
          </Box>
          <IconButton color="inherit" size="small" onClick={() => setOpen(false)}>
            <CloseIcon />
          </IconButton>
        </Box>

        <Box style={{ padding: 16 }}>
          {!content && (
            <Typography style={{ fontSize: 13, color: '#5c6370' }}>
              برای این صفحه راهنمای جداگانه‌ای ثبت نشده. راهنمای کامل سامانه را ببینید.
            </Typography>
          )}
          {content && (
            <>
              <Typography style={{ fontSize: 13.5, color: '#3949ab', fontWeight: 700, marginBottom: 8 }}>
                {content.icon} {content.intro}
              </Typography>
              {content.sections.map((s, i) => (
                <Box key={i} className={classes.section}>
                  <Typography style={{ fontWeight: 800, fontSize: 13, color: '#1a237e', marginBottom: 6 }}>
                    {i + 1}. {s.title}
                  </Typography>
                  {s.body.map((b, j) => (
                    <Typography key={j} style={{ fontSize: 12.5, color: '#43476a', lineHeight: 1.9 }}>
                      • {b}
                    </Typography>
                  ))}
                  {s.tip && <Box className={classes.tip}>💡 {s.tip}</Box>}
                </Box>
              ))}
            </>
          )}

          <Divider style={{ margin: '16px 0 10px' }} />
          <Button fullWidth variant="outlined" size="small"
            onClick={() => { setOpen(false); navigate('/help') }}>
            📖 راهنمای کامل سامانه (هماهنگ با نقش شما)
          </Button>
        </Box>
      </Drawer>
    </>
  )
}

export default HelpDrawer
